jQuery(document).ready(function($) {
    $('p.widget-trigger').on('click', function(e) {
        console.log('button clicked');
        e.preventDefault();
        // Trigger the click event on the button with the class .waiteraid-widget
        $('.waiteraid-widget').click();
    });
});
